import { Pagination } from '../../../models/pagination.model';

export enum EarningStatus {
  PENDING_GRACE = 'PENDING_GRACE',
  AVAILABLE = 'AVAILABLE',
  PROCESSING = 'PROCESSING',
  WITHDRAWN = 'WITHDRAWN',
  SETTLED_DIRECTLY = 'SETTLED_DIRECTLY',
}

export interface Earning {
  _id?: string;
  instructor: string;
  order?: string;
  invoice?: string;
  grossAmount: number;
  platformFee: number;
  netAmount: number;
  status: EarningStatus;
  gracePeriodEndsOn: Date;
  createdAt?: Date;
}

export interface EarningLedger {
  pendingBalance: number;
  availableForWithdrawal: number;
  directSettledBalance?: number;
  totalServiceFees: number;
  totalEarned: number;
}

export interface TreasuryLedger {
  isDefault?: boolean;
  availableForWithdrawal: number;
  pendingBalance: number;
  directSettledBalance: number;
  instructorLiabilities: number;
  instructorPending?: number;
  totalGrossRevenue: number;
  totalPlatformFees: number;
  academyNetProfit: number;
  platformFeeRevenue?: number;
  totalEscrowHeld?: number;
  totalGrossVolume?: number;
  directSettledVolume?: number;
}

export interface UnifiedTransaction {
  _id: string;
  orderId?: string;
  orderReference: string;
  courseTitle: string;
  tenant?: {
    _id: string;
    name: string;
    slug: string;
  };
  instructor?: {
    _id: string;
    firstName?: string;
    lastName?: string;
    username?: string;
  };
  isOwnerTaught?: boolean;
  grossAmount: number;
  platformFee: number;
  instructorShare: number;
  academyNet: number;
  status: EarningStatus;
  createdAt: Date;
}

export interface UnifiedTransactionResponse extends Pagination {
  docs: UnifiedTransaction[];
}

export interface EarningResponse extends Pagination {
  docs: Earning[];
}
